import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-4494eb03"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "row" }
const _hoisted_2 = { class: "col-xxl-12" }
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "col-lg-12 d-flex" }
const _hoisted_5 = { class: "card mb-25 border-0 rounded-0 bg-white flex-grow-1" }
const _hoisted_6 = { class: "card-body p-15 p-sm-20 p-md-25 p-lg-30 letter-spacing" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BreadCrumb = _resolveComponent("BreadCrumb")!
  const _component_CreateAutoSystemClassification = _resolveComponent("CreateAutoSystemClassification")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_BreadCrumb, { PageTitle: "Auto System Classification" }),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _createVNode(_component_CreateAutoSystemClassification, {
                  leadID: _ctx.leadID,
                  dataStreamID: _ctx.dataStreamID
                }, null, 8, ["leadID", "dataStreamID"])
              ])
            ])
          ])
        ])
      ])
    ])
  ], 64))
}